// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"54a833f8","48":"a25c19ed","166":"e32869f7","198":"e6900a9c","246":"153a1a93","347":"d3fd8cc5","464":"8395f07f","771":"5ef29ccf","888":"551fb583"}[chunkId] + ".chunk.js";
};